module.exports = __webpack_public_path__ + "static/media/9-iron.325eefc6.png";